import React, { useEffect } from "react";

export default function AszfPage() {

  useEffect(() => {
    document.title = "ÁSZF - FociFanatik";
  }, []);

  return (
    <div style={{ maxWidth: "900px", margin: "0 auto", padding: "40px 20px" }}>
      <h1>Általános Szerződési Feltételek</h1>

      <h3>1. Az oldal üzemeltetője</h3>
      <p>
        Az oldal üzemeltetője: <b>FociFanatik</b><br />
        Kapcsolat: info@focifanatik.hu
      </p>

      <h3>2. Az oldal célja</h3>
      <p>
        A FociFanatik weboldal célja labdarúgással és sportfogadással kapcsolatos
        statisztikák, elemzések és stratégiák megjelenítése.
        Az oldalon található információk kizárólag tájékoztató jellegűek,
        nem minősülnek pénzügyi vagy fogadási tanácsnak.
      </p>

      <h3>3. Regisztráció</h3>
      <p>
        Az oldal egyes funkciói regisztrációhoz kötöttek.
        A felhasználó a regisztráció során köteles valós adatokat megadni.
      </p>

      <h3>4. Felelősség kizárása</h3>
      <p>
        Az üzemeltető nem vállal felelősséget az oldalon található információk
        felhasználásából eredő esetleges károkért.
        Minden felhasználó saját felelősségére használja az oldalt.
      </p>

      <h3>5. Szerzői jogok</h3>
      <p>
        Az oldalon található tartalmak a FociFanatik tulajdonát képezik.
        Azok másolása vagy terjesztése kizárólag az üzemeltető engedélyével lehetséges.
      </p>

      <h3>6. Adatkezelés</h3>
      <p>
        Az oldal kizárólag a működéshez szükséges technikai adatokat
        (például munkamenet – session cookie) kezeli.
        Az adatokat harmadik félnek nem adjuk át.
      </p>

      <p style={{ marginTop: "40px", fontSize: "14px", opacity: 0.7 }}>
        Hatályos: 2025.01.01.
      </p>
    </div>
  );
}
